import { useTranslation } from 'react-i18next';

import { FormCheckbox, Skeleton, useProductsContext } from 'components';

const SportFilters = () => {
  const { t } = useTranslation();
  const { sportCategories, loadingSportCategories } = useProductsContext();

  return (
    <div>
      <div className="p-6 lg:border-b lg:border-gray-200">
        {loadingSportCategories ? (
          <>
            {Array.from({ length: 6 }).map((_, index) => (
              <div className="flex-center-between gap-2 mb-3 last:mb-0" key={`sport-category-skeleton-${index}`}>
                <div className="flex items-center gap-2">
                  <Skeleton size="sm" />
                  <Skeleton classNames="w-32 h-6" />
                </div>
                <Skeleton size="sm" />
              </div>
            ))}
          </>
        ) : (
          <fieldset>
            <legend className="text-sm font-semibold uppercase mb-6">{t('form:category')}</legend>

            {sportCategories?.map((category, index) => (
              <FormCheckbox
                key={`sport-subcategory-${index}`}
                name={`sportCategory.${category.categoryId}`}
                className="mb-6 last:mb-0"
                customLabel={() => category.label}
                value={category.id}
              />
            ))}
          </fieldset>
        )}
      </div>
    </div>
  );
};

export default SportFilters;
